import ApplicationController from './application_controller';

export default class extends ApplicationController {
  static values = {
    changeText: String,
    noChangeText: String
  }

  static targets = [
    'button',
    'field'
  ]

  connect() {
    if (this.hasFieldTarget) {
      this.existingValue = this.fieldTarget.value
      this.fieldTarget.onchange = () => {
        if (this.hasButtonTarget) {
          if (this.fieldTarget.value != this.existingValue) {         
            this.buttonTarget.innerText = this.changeTextValue
          } else {
            this.buttonTarget.innerText = this.noChangeTextValue
          }
        }
      }
    }
  }
}